module.exports = __webpack_public_path__ + "img/1-icono-nuevo.fa70509c.svg";